import { ContainerIcon, EyeIcon, FilmIcon } from '@braskai/icons';

import { EditorTranslationKey } from '@/shared/i18n/translations/editor';

export const BULLETS = [
  {
    icon: <EyeIcon height={20} width={20} />,
    textKey: 'editor.visualTranslation.criteriaLegible',
  },
  {
    icon: <ContainerIcon height={20} width={20} />,
    textKey: 'editor.visualTranslation.criteriaNotCovered',
  },
  {
    icon: <FilmIcon height={20} width={20} />,
    textKey: 'editor.visualTranslation.criteriaNoAnimations',
  },
] satisfies { icon: JSX.Element; textKey: EditorTranslationKey }[];

export const DATA_TEST_IDS = {
  activity: 'visual-translation-activity',
  activityHistory: 'visual-translation-activity-history',
  autoStartRejected: 'visual-translation-auto-start-rejected',
  downloadDraft: 'visual-translation-download-draft',
  downloadResult: 'visual-translation-download-result',
  draftFooter: 'visual-translation-draft-footer',
  editNow: 'visual-translation-edit-now',
  estimateRetry: 'visual-translation-estimate-retry',
  paywall: 'visual-translation-paywall',
  progress: 'visual-translation-progress',
  queue: 'visual-translation-queue',
  start: 'visual-translation-start',
  talkToSales: 'visual-translation-talk-to-sales',
  translateAgain: 'visual-translation-translate-again',
  tryAgain: 'visual-translation-try-again',
};

// localization_app reasons (OnscreenEstimate.reason) that the tab explains in its own words.
export const ESTIMATE_REASONS = {
  alreadyRunning: 'onscreen_already_running_error',
  // New starts are paused (ONSCREEN__STARTS_ENABLED=false); runs already made stay to follow and download.
  disabled: 'onscreen_disabled_error',
  notReady: 'onscreen_project_not_ready_error',
  tooLong: 'onscreen_video_too_long_error',
} as const;
